
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/camplejeuneapplication/privacy-policy",
      function () {
        return require("private-next-pages/camplejeuneapplication/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/camplejeuneapplication/privacy-policy"])
      });
    }
  